import { LitElement, html, css } from 'lit-element';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-select';
import { connect } from '../store/connect';
import { actions, selectors } from './';
import { selectors as userSelectors } from '../user';
import { getRouter } from '../routing/route-base';
import './admin-context-tool';

// maybe rename to activeAuthSite or set-auth-site or auth-site-menu
class AppAdminContext extends LitElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-flow: column;
                }
                tmn-select {
                    width: 160px;
                }
            `,
        ];
    }

    static get properties() {
        return {
            availableAuthSites: {
                type: Array,
            },
            activeAuthSite: {
                type: String,
            },
        };
    }
    rendeSingleContextView() {
        const { activeAuthSite } = this;
        return html`<span>${activeAuthSite}</span>`;
    }
    render() {
        const { availableAuthSites = [], activeAuthSite } = this;
        const dataForSelect = availableAuthSites.map((o) => ({
            name: o.name,
            displayKey: o.name,
            sport: o.sport,
        }));
        const threshHoldForShowingSearchUI = 20;
        if (availableAuthSites?.length > threshHoldForShowingSearchUI) {
            return html`<admin-context-tool></admin-context-tool>`;
        }
        // this will be less than threshHoldForShowingSearchUI
        if (availableAuthSites?.length > 1) {
            const selections = dataForSelect.filter((d) => activeAuthSite === d.displayKey);
            return html`<tmn-select
                @tmn-selections-changed=${this.handleSelectChanged}
                .multiple=${false}
                .placeholder=${'Select User Admin Site'}
                .data=${dataForSelect}
                .selections=${selections}></tmn-select>`;
        }
        return this.rendeSingleContextView();
    }

    handleSelectChanged(e) {
        const { detail } = e;
        const { selections } = detail;
        const { name } = selections[0];
        const router = getRouter();
        router.navigateByName('user-list', { authSite: name });
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        const availableAuthSites = selectors.availableAuthSitesSelector(state);
        const activeAuthSite = userSelectors.activeAuthSiteNameSelector(state);
        return {
            availableAuthSites,
            activeAuthSite,
        };
    };
};

customElements.define('app-admin-context', connect(mapStateToProps, actions)(AppAdminContext));
